export const Notification_Types = {
  INFO: "info",
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};

export const NOTIFICATION_ACTIONS = {
  DOWNLOAD: "Download",
  NAVIGATE: "Navigate",
};
